import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import DesktopDownloadsPage from './DesktopDownloadsPage';

const manifest = {
  id: 'eagle-desktop',
  nameKey: 'extensions.eagle_desktop.name',
  descriptionKey: 'extensions.eagle_desktop.description',
  icon: ComputerOutlinedIcon,
  route: '/eagle-desktop',
  menuItem: {
    labelKey: 'extensions.eagle_desktop.menu',
    path: '/eagle-desktop',
  },
  requiredExtensions: [],
  Page: DesktopDownloadsPage,
};

export default manifest;
